import React from 'react';
import './Specialization.css';

const Specialization = () => (
  <div className="specialization-page">
    <div className="container">
      <h1 className="specialization-title">Specialization</h1>
      <p className="specialization-desc">Explore our specialized programs designed to help you master in-demand skills and advance your career. More content coming soon!</p>
    </div>
  </div>
);

export default Specialization; 